// ----------------------------------------------------------------------------
// Component: Intro Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_quick-nav.scss';

document.addEventListener('DOMContentLoaded', function() {
    const quickNav = document.querySelector('.quick-nav');
    const stickyOffset = quickNav.offsetTop;
    const headerSection = document.querySelector('#shopify-section-header'); // Assuming the header has this class
  
    // Add a scroll event listener to the window
    window.addEventListener('scroll', function() {
        // Use scrollY to check the current scroll position
        if (window.scrollY >= stickyOffset) {
            quickNav.classList.add('sticky');
  
            // Check if the header has the is-sticky class
            if (headerSection.classList.contains('is-sticky')) {
                if (window.innerWidth <= 1024) {
                    quickNav.style.top = '52px'; // Set top to 52px when the header is sticky and screen width is 1024px or less
                } else {
                    quickNav.style.top = '60px'; // Set top to 60px when the header is sticky and screen width is greater than 1024px
                }
            } else {
                quickNav.style.top = '0'; // Set top to 0 when the header is not sticky
            }
        } else {
            quickNav.classList.remove('sticky');
            quickNav.style.top = '0'; // Reset the top value when not sticky
        }
    });
});
  